const API_BASE = process.env.REACT_APP_API_URL || 'https://api.grandindigoembroidery.com';

const headers = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

const IMAGE_BASE = 'https://admin.grandindigoembroidery.com/public/storage';

export const getPortfolioImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (imagePath.startsWith('http')) return imagePath;
  return `${IMAGE_BASE}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
};

/**
 * Fetch all active portfolio categories.
 * @returns {Promise<Category[]>}
 */
export const getPortfolioCategories = async () => {
  const res = await fetch(`${API_BASE}/portfolio/categories`, { method: 'GET', headers: headers() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to fetch categories.');
  return data.categories ?? data;
};

/**
 * Fetch active portfolio items for a given category id.
 * @param {number} categoryId
 * @returns {Promise<Item[]>}
 */
export const getPortfolioItems = async (categoryId) => {
  const res = await fetch(`${API_BASE}/portfolio/items/${categoryId}`, { method: 'GET', headers: headers() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to fetch portfolio items.');
  return data.items ?? data;
};